// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__QXkt9","additionalInfo":"AgreementModal_additionalInfo__Sq8g1"};